export default __webpack_public_path__ + "static/media/left.6b652fe0.png";